"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const sockette_1 = (0, tslib_1.__importDefault)(require("sockette"));
const events_1 = require("events");
const _1 = require(".");
if (!globalThis.WebSocket) {
    const WebSocket = require('ws');
    globalThis.WebSocket = WebSocket;
}
class LumiaSdk extends events_1.EventEmitter {
    constructor(config) {
        super();
        this._messageIdCounter = 1;
        this._connected = false;
        this._promises = {};
        this._data = {
            host: 'localhost',
            port: 39231,
            name: null,
            token: null,
            timeout: 30000,
        };
        this.init = (config) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            try {
                if (config === null || config === void 0 ? void 0 : config.token) {
                    this._data = Object.assign(Object.assign({}, this._data), config);
                }
                yield this._startWebsockets();
                this._connected = true;
                return true;
            }
            catch (err) {
                this._connected = false;
                return false;
            }
        });
        this.getInfo = () => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            try {
                const result = yield this._sendWebsocketMessage({
                    retrieve: true,
                    method: 'retrieve',
                });
                return result;
            }
            catch (err) {
                return new Error(err.message);
            }
        });
        this.stop = () => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            clearInterval(this._heartbeatInterval);
            clearTimeout(this._websocketConnectTimeout);
            try {
                yield this._sendWebsocketMessage({
                    method: 'stop',
                });
            }
            catch (err) { }
            try {
                if (this._websocket) {
                    this._websocket.close();
                }
            }
            catch (err) {
                this._websocket = null;
            }
            this.emit('closed');
            return this;
        });
        this._startWebsockets = () => {
            return new Promise((resolve, reject) => {
                if (!this._data.token) {
                    return reject('No token has been set');
                }
                if (this._websocket) {
                    this._websocket.close();
                }
                this._websocketConnectTimeout = setTimeout(() => {
                    this._websocket.close();
                    return reject('Setup timed out. Could not connect');
                }, this._data.timeout);
                this._websocket = new sockette_1.default(`ws://${this._data.host}:${this._data.port}/api?token=${this._data.token}&name=${this._data.name}`, {
                    timeout: 5000,
                    onopen: (e) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
                        clearTimeout(this._websocketConnectTimeout);
                        this._connected = true;
                        this.emit('connected');
                        resolve(true);
                    }),
                    onmessage: this._handleMessage,
                    onreconnect: (e) => {
                        this.emit('reconnecting');
                    },
                    onmaximum: (e) => {
                        this.emit('maximum:reconnect');
                    },
                    onclose: (e) => {
                        this._connected = false;
                        this.emit('closing', e.code);
                        if (e.code === 1000 || e.code === 1001 || e.code === 1005) {
                            this.stop();
                        }
                    },
                    onerror: (event) => {
                        if (!this._connected) {
                            this.emit('unauthorized', 'token is invalid');
                            return reject('token is invalid');
                        }
                        else {
                            this.emit('error', event.message);
                        }
                    },
                });
            });
        };
        this._handleMessage = (message) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            try {
                const _a = JSON.parse(message.data), { context, event } = _a, msg = (0, tslib_1.__rest)(_a, ["context", "event"]);
                if (context) {
                    if (msg.status === 200 || !msg.status) {
                        this._promises[context].resolve(msg);
                    }
                    else {
                        this._promises[context].reject(msg);
                    }
                    return;
                }
                this.emit('event', Object.assign({ event }, msg));
            }
            catch (err) {
                this.emit('error', 'Handle Message err');
            }
        });
        this._sendWebsocketMessage = (event) => {
            return new Promise((resolve, reject) => {
                const context = (this._messageIdCounter++).toString();
                if (this._websocket) {
                    event.context = context;
                    this._promises[context] = { resolve, reject };
                    this._websocket.send(JSON.stringify(event));
                }
            });
        };
        this.send = (pack) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            try {
                const result = yield this._sendWebsocketMessage(Object.assign({ lsorigin: 'lumia-sdk' }, pack));
                this.emit('sent:message', result);
                return result;
            }
            catch (err) {
                this.emit('error:send', err.toString());
                return err.toString();
            }
        });
        this.sendAlert = (pack) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            return this.send({
                type: _1.LumiaActivityCommandTypes.ALERT,
                params: {
                    value: pack.alert,
                },
            });
        });
        this.sendCommand = (pack) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            return this.send({
                type: _1.LumiaActivityCommandTypes.CHAT_COMMAND,
                params: {
                    value: pack.command,
                    hold: pack.default,
                    skipQueue: pack.skipQueue,
                },
            });
        });
        this.sendColor = (pack) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            return this.send({
                type: _1.LumiaActivityCommandTypes.RGB_COLOR,
                params: {
                    value: pack.color,
                    brightness: pack.brightness,
                    transition: pack.transition,
                    duration: pack.duration,
                    skipQueue: pack.skipQueue,
                    hold: pack.default,
                    lights: pack.lights,
                },
            });
        });
        this.sendBrightness = (pack) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            return this.send({
                type: _1.LumiaActivityCommandTypes.RGB_COLOR,
                params: {
                    value: null,
                    brightness: pack.brightness,
                    transition: pack.transition,
                    skipQueue: pack.skipQueue,
                },
            });
        });
        this.sendTts = (pack) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            return this.send({
                type: _1.LumiaActivityCommandTypes.TTS,
                params: {
                    value: pack.text,
                    volume: pack.volume,
                    voice: pack.voice,
                },
            });
        });
        this.sendChatbot = (pack) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            return this.send({
                type: _1.LumiaActivityCommandTypes.CHATBOT_MESSAGE,
                params: {
                    value: pack.text,
                    platform: pack.platform,
                },
            });
        });
        this.getGamesGlowSettings = () => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            try {
                const result = yield this._sendWebsocketMessage({
                    method: 'gamesGlowSettings',
                    gamesGlowId: this._data.name,
                });
                return result;
            }
            catch (err) {
                return new Error(err.message);
            }
        });
        this.sendGamesGlowAlert = (pack) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            return this.send({
                type: _1.LumiaActivityCommandTypes.GAMESGLOW_ALERT,
                gamesGlowId: this._data.name,
                gamesGlowKey: pack.gamesGlowKey,
                params: {
                    value: pack.value,
                },
            });
        });
        this.sendGamesGlowCommand = (pack) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            return this.send({
                type: _1.LumiaActivityCommandTypes.GAMESGLOW_COMMAND,
                gamesGlowId: this._data.name,
                gamesGlowKey: pack.gamesGlowKey,
                params: {
                    value: pack.value,
                },
            });
        });
        this.sendGamesGlowVariableUpdate = (pack) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            return this.send({
                type: _1.LumiaActivityCommandTypes.GAMESGLOW_VARIABLE,
                gamesGlowId: this._data.name,
                gamesGlowKey: pack.gamesGlowKey,
                params: {
                    value: pack.value,
                },
            });
        });
        this.sendGamesGlowVirtualLightsChange = (pack) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            return this.send({
                type: _1.LumiaActivityCommandTypes.GAMESGLOW_VIRTUALLIGHT,
                gamesGlowId: this._data.name,
                gamesGlowKey: pack.gamesGlowKey,
                params: {
                    value: pack.value,
                },
            });
        });
        this._data = Object.assign(Object.assign({}, this._data), config);
        return this;
    }
}
exports.default = LumiaSdk;



//////////////////
// WEBPACK FOOTER
// ./~/@lumiastream/sdk/lib/esm/lumia-sdk.js
// module id = 319
// module chunks = 0